import { isMockMode, post, simulateDelay } from "../api";
import { setLicencesState } from "./getForUser";

export const getLicencesForLicenceView = (data) => {
	if (isMockMode()) {
		const testData = [
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2023-10-30T13:00:00",
				licenceExpirationUtc: "2023-12-31T05:00:00",
				lastUsedUtc: "2022-11-30T16:51:13.9888673",
				lastActivatedUtc: "2022-11-01T13:30:10.869361",
				isRevoked: false,
				assignedDateUtc: "2023-01-01T22:30:38.438",
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2023-10-30T13:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-12-02T17:36:47.5798543",
				lastActivatedUtc: "2022-11-07T18:18:09.6029871",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2023-10-30T13:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-11-23T13:23:36.8975146",
				lastActivatedUtc: "2022-11-09T08:46:33.9160783",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2023-10-30T13:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-11-23T14:37:05.1379533",
				lastActivatedUtc: "2022-11-08T06:45:41.1058054",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2023-10-30T13:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-12-04T16:15:58.8768969",
				lastActivatedUtc: "2022-11-18T20:36:44.5491076",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-31T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2023-01-01T23:48:52.0194019",
				lastActivatedUtc: "2022-12-09T05:45:04.1887129",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-31T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-12-05T00:12:55.8441417",
				lastActivatedUtc: "2022-11-01T22:23:58.5135313",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-31T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-12-19T03:21:03.4980308",
				lastActivatedUtc: "2022-11-01T09:24:06.363275",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-31T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-11-10T04:18:27.6616881",
				lastActivatedUtc: "2022-11-08T06:15:26.3680488",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-31T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-09-28T00:39:43.6321885",
				lastActivatedUtc: "2022-09-28T00:39:43.6321885",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-11-02T23:09:19.4629076",
				lastActivatedUtc: "2022-11-01T09:30:38.5461194",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-09-27T05:59:08.4268587",
				lastActivatedUtc: "2022-09-27T05:59:08.4268587",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-10-28T02:48:55.7589981",
				lastActivatedUtc: "2022-10-27T22:48:16.8293943",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-11-10T01:53:59.0053907",
				lastActivatedUtc: "2022-08-03T03:34:15.0227249",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-09-21T06:45:23.3349838",
				lastActivatedUtc: "2022-08-08T04:53:13.8167528",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-10-24T00:14:12.5532155",
				lastActivatedUtc: "2022-08-08T04:29:58.5894361",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-08-30T00:05:15.4470479",
				lastActivatedUtc: "2022-08-29T06:01:01.1796711",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-08-30T00:08:16.8266261",
				lastActivatedUtc: "2022-08-29T06:10:02.424918",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-08-30T00:08:24.0156631",
				lastActivatedUtc: "2022-08-29T06:08:00.5162679",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-08-30T06:05:44.2739006",
				lastActivatedUtc: "2022-08-29T06:01:19.8252882",
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2050-08-30T14:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: "GHOST_IN_THE",
				finalExpirationUtc: "2049-12-29T00:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: "2022-10-05T04:35:54.5791909",
				lastActivatedUtc: "2022-09-28T06:56:50.0816423",
				isRevoked: true,
			},
			{
				assignedToUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				assignedByUser: {
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
				subscriptionId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				activeMachine: null,
				finalExpirationUtc: "2023-12-05T13:00:00",
				licenceExpirationUtc: null,
				lastUsedUtc: null,
				lastActivatedUtc: null,
				isRevoked: false,
			},
		];

		return simulateDelay(50, () => setLicencesState(testData));
	}

	return post(`licences/getforlicenceview`, data).then(setLicencesState);
};
